<template>
  <div class="components_warp">
      <div class="top-container">
        <div class="time">
            <i class="el-icon-time"></i> {{ min }}:{{ sec }}
          </div>
          <div v-for="(topic, index) in topics" :key="index">
            <div v-if="index == curIndex">
              <div v-if="index == 8">
                  <div class="text_bewrite2">
                    <p>{{topic.topic}}</p>
                  </div>
                  <div class="top-content1">
                    <div class="img-box2" v-for="(t, index) in topic.options.slice(0,3)" :key="index">
                      <div class="img-box">
                        <img :src="t.optImg" alt="" />
                      </div>
                      <p>{{letterArr[index]}}</p>
                    </div>
                  
                  </div>
                  <div class="radio-list">
                    <section class="light">
    
                      <ul>
                        <li v-for="(t, index) in topic.options.slice(3,9)" :key="index">
                          
                            <div
                            style="
                              width: 100px;
                              height: 100px;
                            "
                          ><img :src="t.optImg" alt="">
                          </div>
                          <label>
                            <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                            <span class="design"></span>
                            <span class="text">{{letterDEFG[index]}}</span>
                          </label>
                        </li>

                      </ul>
                    </section>
                  </div>
              </div>
              <div v-else>
                 <div class="text_bewrite2">
                <p>{{topic.topic}}</p>
              </div>
              <div class="top-content">
                <div class="img-box">
                  <img :src="topic.img" alt="" />
                </div>
              </div>
              <div class="radio-list">
                <section class="light">
                 <div v-if="topic.options.length>6">
                    <ul>
                    <li v-for="(t, index) in topic.options" :key="index" style="width:120px">
                      
                        <div
                        style="
                          width: 100px;
                          height: 100px;
                        "
                      ><img :src="t.optImg" alt="">
                      </div>
                      <label>
                        <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                        <span class="design"></span>
                        <span class="text">{{letterArr[index]}}</span>
                      </label>
                    </li>

                  </ul>
                 </div>
                  <div v-else>
                    <ul>
                    <li v-for="(t, index) in topic.options" :key="index">
                      
                        <div
                            :style="{width:curIndex!=3?'100px':'',height:curIndex!=3?'100px':''}"
                      ><img :src="t.optImg" alt="">
                      </div>
                      <label>
                        <input class="radio_btn" type="radio" name="light" v-model="radioVal" :value="t.optOrder" />
                        <span class="design"></span>
                        <span class="text">{{letterArr[index]}}</span>
                      </label>
                    </li>

                  </ul>
                 </div>
                </section>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_warp">
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="next">确定</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >
        </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            min:'',
            sec:'',
            end:'',
            clearTime:'',
            startTime:'',
            endTime:'',
            tempTime:'',
            curTempTime:'',
            curIndex: 0,
            topics: [],
            answers:[],
            radioVal:'',
            letterArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
            letterDEFG:["D","E","F","G","H"],
            url:{path:'/careerevalution/home',query: { name:'znsp',part:'znsp33'}}
        }
    },
    created() {
    this.getTopicApi();
  },
  mounted(){
    this.startTime = new Date().getTime();
    this.end = Date.parse(new Date()) + 720000 // 截止时间为7分钟（1min为60000ms,）
    this.countdown()
  },
  destroyed(){
    clearTimeout(this.clearTime)
  },
  methods: {
    countdown () {
      const end = this.end
      const now = Date.parse(new Date())
      const msec = end - now
      if(msec<0) return;

    //  let day = parseInt(msec / 1000 / 60 / 60 / 24)
    //  let hr = parseInt(msec / 1000 / 60 / 60 % 24)
      let min = parseInt(msec / 1000 / 60 % 60)
      let sec = parseInt(msec / 1000 % 60)
    //  this.day = day
    //  this.hr = hr > 9 ? hr : '0' + hr
      this.min = min > 9 ? min : '0' + min
      this.sec = sec > 9 ? sec : '0' + sec
      const that = this
      if(min>=0 && sec>=0){
        //倒计时结束
        if(min==0 && sec==0){
          this.saveNode(2,33,()=>{
            this.submit()
          })
        }
       this.clearTime = setTimeout(function () {
          that.countdown()
        }, 1000)
      }
    },
    getTopicApi() {
      this.$ajax
        .post(
          `${this.G_capi}${this.ports.careerEvaluation.znsp.kjnlList2}`,
          {},
          {
            headers: {
              token: sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          this.topics = res.data.data;
          console.log(this.topics);
        });
    },
    next() {

      if(this.radioVal == ""){
        this.$message.error('请选择答案')
        return false
      }
      this.curTempTime = new Date().getTime();
      console.log(this.radioVal)
      if(this.radioVal == 1){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'A'
        })
      }else if(this.radioVal == 2){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'B'
        })
      }else if(this.radioVal == 3){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'C'
        })
      }else if(this.radioVal == 4){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'D'
        })
      }else if(this.radioVal == 5){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'E'
        })
      }else if(this.radioVal == 6){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'F'
        })
      }else if(this.radioVal == 7){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'G'
        })
      }else if(this.radioVal == 8){
        this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:'H'
        })
      }

      this.radioVal = ''

      if (this.curIndex + 1 < this.topics.length) {
        this.curIndex++;
      } else {
        this.saveNode(2,33,()=>{
          this.submit()
        })
      }
    },
    submit(){ //提交
      this.endTime = new Date().getTime();//结束时间
      this.tempTime = Number(this.endTime) - Number(this.startTime);
      this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.kjnlAdd2}`,{
          testId:sessionStorage.getItem('testId'),
          time:this.tempTime,
          answers:this.answers,
      },{
            headers:{
              token:sessionStorage.getItem('token')
            }
        })
        .then((res) => {
            var data = res.data;
          if(data.code==2000){
            this.$router.push({
              path: "/careerevalution/success",
              query: {
                type: "answer",
                url:this.url,
              },
            });
          }
        })
    },
  },
}
</script>

<style scoped>
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.text_bewrite2 p {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.title h4 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.btn_warp {
  display: flex;
  justify-content: space-between;
}
/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}

.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;

}
.top-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 15px;
}
.top-content1{
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.img-box {
  width: 200px;
  height: 150px;
}
img {
  height: 100%;
  width: 100%;
}
.img-box p {
  text-align: center;
}

/* 单选按钮 */

.light {
  --primary: #29d3ec;
  --other: #29d3ec;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  top:30px
}
.light ul {
  display: flex;
}
.light ul li {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dark {
  --primary: hsl(1, 100%, 68%);
  --other: hsl(0, 0%, 90%);
  background: hsl(0, 0%, 10%);
}

/* h1 */
h1 {
  color: var(--other);
  padding: 8px 4px;
  border-bottom: 2px solid var(--other);
}

/* label */
label {
  width: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  margin: 12px 0;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
}

/* input */
.radio_btn {
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: -1;
}

/* .design */
.design {
  width: 16px;
  height: 16px;
  border: 1px solid var(--other);
  border-radius: 100%;
  margin-right: 16px;
  position: relative;
  top: 15px;
}
.design em {
  display: inline-block;
  position: absolute;
  left: 30px;
  top: -1px;
  font-style: normal;
  vertical-align: middle;
}

.design::before,
.design::after {
  content: "";
  display: block;

  width: inherit;
  height: inherit;

  border-radius: inherit;

  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}

.design:before {
  background: var(--other);
  opacity: 0;
  transition: 0.3s;
}

.design::after {
  background: var(--primary);
  opacity: 0.4;
  transition: 0.6s;
}

/* .text */
.text {
  /* font-weight: bold; */
  margin-left: -15px;
}

/* checked state */
.radio_btn:checked + .design::before {
  opacity: 1;
  -webkit-transform: scale(0.6);
  transform: scale(0.6);
}
.radio_btn:focus + .design::after,
.radio_btn:active + .design::after {

}
.time {
  position: absolute;
  top: 40px;
  right: 40px;
  color: red;
}
</style>